
/**
 * Cache to register feature roles for the current user
 * @kind cache
 * @class FeatureRolesLookup
 * @description Custom lookup cache for FeatureRoles
 * @usage let lookup = await Grape.cache.get('FeatureRolesLookup');
 */
export default {
	name: 'FeatureRolesLookup',
	options: {
		refresh: async function (cb) {
			try {
				let res = await Grape.fetches.getJSON('/settings/get_user_features_access', {});
				if (res != null)
					cb(null, res.result || []);

			} catch (e) {
				cb(e, null);
			}
		},
		get: async function () {
            return new Promise((resolve, reject) => {
                this.refresh((err, result) => {
                    if (err) {
                        reject(err);
                    } else {
                        resolve(result);
                    }
                });
            });
        }
	}
};
